import { TableProps } from 'antd';
import { ReactElement } from 'react';

import { AppTable } from '@/common/components';

import { SearchConsoleAnalyticsDimensions, SearchConsoleAnalyticsDimensionsKeys, SearchConsoleAnalyticsRowKeysColor } from '@/modules/Domains';

import tableColumns from './DimensionTableColumns';

interface Props<D extends SearchConsoleAnalyticsDimensionsKeys> {
  dimension: SearchConsoleAnalyticsDimensionsKeys;
  rows: SearchConsoleAnalyticsDimensions[D];
  itemsColor: SearchConsoleAnalyticsRowKeysColor;
}

export const DimensionTable: <T extends SearchConsoleAnalyticsDimensionsKeys>
(props: Props<T>) => ReactElement<Props<T>> = ({ dimension, rows, itemsColor }) => {
  const dataSource: TableProps['dataSource'] = rows?.map((row) => {
    return {
      key: `${ dimension }-${ row.key }`,
      keyValue: row.key,
      clicks: row.clicks,
      impressions: row.impressions,
      ctr: row.ctr,
      position: row.position,
    };
  });

  return (
    <AppTable
      sortDirections={ ['descend', 'ascend'] }
      size="small"
      showSorterTooltip={ false }
      dataSource={ dataSource }
      columns={ tableColumns({ dimension, itemsColor }) }
    />
  );
};
